export default "__VITE_ASSET__1f578160__"